module.exports = __webpack_public_path__ + "images/button-arrow-black.svg";